const routers = [
    {
        path: '/',
        name: 'login',
        component: () => import('~/components/login.vue')
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('~/components/home.vue'),
        children: [
            {
                path: '/report/new',
                name: 'newReport',
                component: () => import('~/components/report/newReport.vue'),
            },
            {
                path: '/report/generate',
                name: 'generateReport',
                component: () => import('~/components/report/generateReport.vue'),
            },
            {
                path: '/report/category',
                name: 'categoryReport',
                component: () => import('~/components/report/createCategory.vue'),
            },
            {
                path: '/report/four',
                name: 'fourReport',
                component: () => import('~/components/report/fourDimensionalAge.vue'),
            },
            {
                path: '/report/painDiary',
                name: 'painDiary',
                component: () => import('~/components/report/painDiary.vue'),
            },
            {
                path: '/photo/bind',
                name: 'photoBind',
                component: () => import('~/components/photo/photoBind.vue'),
            },
            {
                path: '/user/query',
                name: 'userQuery',
                component: () => import('~/components/user/userQuery.vue'),
            },
            {
                path: '/user/order/verification',
                name: 'orderVerification',
                component: () => import('~/components/user/orderVerification.vue'),
            },
            {
                path: '/user/:userId/course-calendar',
                name: 'userCourseCalendar',
                component: () => import('~/components/user/userCourseCalendar.vue'),
            },
            {
                path: '/user/:userId/questionnaire',
                name: 'userQuestionnaire',
                component: () => import('~/components/user/userQuestionnaireDetail.vue'),
            },
            {
                path: '/therapist/calendar/week',
                name: 'therapistWeekCalendar',
                component: () => import('~/components/therapist/therapistWeekCalendar.vue'),
            },
            {
                path: '/therapist/dashboard',
                name: 'therapistDashboard',
                component: () => import('~/components/therapist/therapistDashboard.vue'),
            },
            {
                path: '/therapist/list',
                name: 'therapistList',
                component: () => import('~/components/therapist/therapistList.vue'),
            },
            {
                path: '/system/source',
                name: 'userSourceManage',
                component: () => import('~/components/system/userSourceManage.vue'),
            },
            {
                path: '/system/camp',
                name: 'campManage',
                component: () => import('~/components/system/campManage.vue'),
            },
            {
                path: '/statistics/user-flow-funnel',
                name: 'userFlowFunnel',
                component: () => import('~/components/statistics/userFlowFunnel.vue'),
            },
            {
                path: '/statistics/layered-funnel',
                name: 'layeredFunnel',
                component: () => import('~/components/statistics/layeredFunnel.vue'),
            },
            {
                path: '/statistics/weekly-statistics',
                name: 'weeklyStatistics',
                component: () => import('~/components/statistics/weeklyStatistics.vue'),
            },
        ]
    }]
export default routers


// WEBPACK FOOTER //
// ./src/router/routers.js